var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"justify-content-center d-flex flex-column"},[_c('el-image',{staticStyle:{"max-width":"250px"},attrs:{"src":_vm.href}}),_c('div',[_c('div',{staticClass:"d-flex font-size-16 fw-semibold"},[_c('div',{},[_vm._v("Nhắc hẹn:")]),_c('div',[_vm._v(_vm._s(_vm.title))])]),_c('div',[_vm._v(_vm._s(_vm.description))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }